// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class CollectionNavCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      disabled: true,
      breakpoints: {
        '(min-width: 768px)': {
          disabled: false,
          slides: {
            perView: 5,
            spacing: 0,
          },
        },
      },
    })
  }
}

if (!customElements.get('collection-nav-carousel')) {
  customElements.define('collection-nav-carousel', CollectionNavCarousel)
}
